import { SiteUnitListModel } from '@portal-clients/site-unit';

export const sortSiteUnitsFavoritesFirst = (
  siteUnits: SiteUnitListModel[],
  favoriteIds: string[] | undefined,
): SiteUnitListModel[] => {
  if (!favoriteIds?.length || siteUnits.length <= 1) {
    return siteUnits;
  }

  const favSet = new Set(favoriteIds);
  const favourites: SiteUnitListModel[] = [];
  const others: SiteUnitListModel[] = [];

  for (const siteUnit of siteUnits) {
    if (favSet.has(siteUnit.id)) {
      favourites.push(siteUnit);
    } else {
      others.push(siteUnit);
    }
  }

  return [...favourites, ...others];
};
